import commonLayouts from '@/common/plugins/common-layouts';
import stylesPlugin from '@/common/plugins/styles';

export default {
    install(vue: any) {
        vue.use(stylesPlugin);
        vue.use(commonLayouts);
    },
};
